import React from 'react';
import { Row, Col } from 'antd';
import moment, { Moment } from 'moment';
import { I18n } from '@aws-amplify/core';

import { Filters } from './Filters';
import { FileTable } from './FileTable';
import { useQueryParams } from '@/hooks/v2/useQueryParams';
import { useApplicationContext } from '@/context/v1/Application/context';
import { Resolution886ReportFilesProvider } from '@/context/Resolution886ReportFiles';
import * as S from './styles';
import { useCreateReview } from '../../Step/components/hooks/useCreateReview';

export function VideoSelection(): JSX.Element {
	const query = useQueryParams();
	const { organization, company } = useApplicationContext();
	const { newReview, previousReview, useReviewFiles, handleSetUseReviewFiles } = useCreateReview();

	const organization_id = query.get('organization_id') || organization?.id;
	const company_id = query.get('company_id') || company?.id;
	const sector_id = query.get('sector_id') || undefined;
	const line_id = query.get('line_id') || undefined;
	const workstation_id = query.get('workstation_id') || undefined;
	const file_name = query.get('file_name') || undefined;
	const upload_date = query.get('upload_date') || undefined;
	const offset = query.get('offset') || 0;
	const limit = query.get('limit') || 10;

	const queryFilters = {
		organization_id,
		company_id,
		sector_id,
		line_id,
		workstation_id,
		file_name,
		offset: Number(offset),
		limit: Number(limit),
		start_date: handleFormatDate()?.[0],
		end_date: handleFormatDate()?.[1]
	};

	function handleFormatDate(): Moment[] | undefined {
		if (!upload_date) return undefined;
		const [start_date, end_date] = upload_date.split(',');
		return [moment(start_date), moment(end_date)];
	}

	return (
		<Resolution886ReportFilesProvider queryFilters={queryFilters}>
			<Row gutter={[0, 30]} justify="center" align="middle">
				<Col span={24}>
					<S.CustomTitle>{I18n.get('Video selection')}</S.CustomTitle>
					<S.CustomParagraph>
						{I18n.get('Select the video file below for the task you want to analyze')}
					</S.CustomParagraph>
					{(newReview || previousReview?.id) && (
						<S.CustomButtonDefault
							type="default"
							onClick={() => handleSetUseReviewFiles(!useReviewFiles)}
							className={useReviewFiles ? 'active' : ''}
						>
							{I18n.get('Use previous files')}
						</S.CustomButtonDefault>
					)}
				</Col>
				<Col span={24}>
					<Filters />
				</Col>
				<Col span={24}>
					<FileTable />
				</Col>
			</Row>
		</Resolution886ReportFilesProvider>
	);
}
